import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
import uLogin from '@/views/user/Login.vue';
import uMain from '@/views/user/Main.vue';
import uUserInfoAdd from '@/views/user/UserInfoAdd.vue';
import uUserHistory from '@/views/user/UserHistory.vue';
import uUserInfo from '@/views/user/UserInfo.vue';
import uPayFin from '@/views/user/PayFin.vue';
import uSendEdit from '@/views/user/SendEdit.vue';
import uLeave from '@/views/user/Leave.vue';
import uPassReset from '@/views/user/PassReset.vue';
import uPassSet from '@/views/user/PassSet.vue';
import uFinalConfirm from '@/views/user/FinalConfirm.vue';
import mLogin from '@/views/manage/Login.vue';
import mMain from '@/views/manage/Main.vue';
import mCustomerDetail from '@/views/manage/CustomerDetail.vue';
import mCustomerList from '@/views/manage/CustomerList.vue';
import mCustomerMail from '@/views/manage/CustomerMail.vue';
import mSendMailHistory from '@/views/manage/SendMailHistory.vue';
import mSendMailHistoryDetail from '@/views/manage/SendMailHistoryDetail.vue';
import mDownload from '@/views/manage/Download.vue';

Vue.use(Router);

const user_name = '/user';
const manage_name = '/manage';

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // ユーザー側画面
    {
      path: `${user_name}`,
      name: 'uLogin',
      component: uLogin,
    },
    {
      path: `${user_name}/main`,
      name: 'uMain',
      component: uMain,
    },
    {
      path: `${user_name}/user_info_add`,
      name: 'uUserInfoAdd',
      component: uUserInfoAdd,
    },
    {
      path: `${user_name}/user_history`,
      name: 'uHistory',
      component: uUserHistory,
    },
    {
      path: `${user_name}/user_info`,
      name: 'uInfo',
      component: uUserInfo,
    },
    {
      path: `${user_name}/pay_fin`,
      name: 'uPayFin',
      component: uPayFin,
    },
    {
      path: `${user_name}/send_edit`,
      name: 'uSendEdit',
      component: uSendEdit,
    },
    {
      path: `${user_name}/leave`,
      name: 'uLeave',
      component: uLeave,
    },
    {
      path: `${user_name}/pass_reset`,
      name: 'uPassReset',
      component: uPassReset,
    },
    {
      path: `${user_name}/pass_set/:token`,
      name: 'uPassSet',
      component: uPassSet,
    },
    {
      path: `${user_name}/final_confirm`,
      name: 'uFinalConfirm',
      component: uFinalConfirm,
    },
    // 管理側画面
    {
      path: `${manage_name}`,
      name: 'mLogin',
      component: mLogin,
    },
    {
      // 注文一覧
      path: `${manage_name}/main`,
      name: 'mMain',
      component: mMain,
    },
    {
      // 会員詳細
      path: `${manage_name}/customer/:id/type/:type`,
      name: 'mCustomerDetail',
      component: mCustomerDetail,
    },
    {
      // 会員詳細
      path: `${manage_name}/customer_list`,
      name: 'mCustomerList',
      component: mCustomerList,
    },
    {
      // メール送信
      path: `${manage_name}/customer_mail`,
      name: 'mCustomerMail',
      component: mCustomerMail,
    },
    {
      // メール送信履歴
      path: `${manage_name}/send_mail_history`,
      name: 'mSendMailHistory',
      component: mSendMailHistory,
    },
    {
      // メール送信履歴詳細
      path: `${manage_name}/send_mail_history_detail/:id`,
      name: 'mSendMailHistoryDetail',
      component: mSendMailHistoryDetail,
    },
    {
      // ダウンロード
      path: `${manage_name}/download`,
      name: 'mDownload',
      component: mDownload,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path === `${user_name}` ||
    to.path === `${manage_name}` ||
    to.path === `${user_name}/user_info_add` ||
    to.path === `${user_name}/pass_reset` ||
    to.name === 'uPassSet'
  ) {
    next();
    return;
  }
  const urls = to.path.split('/');
  if (`/${urls[1]}` === `${user_name}`) {
    if (store.getters['uLoginInfo/login_token'] === null || store.getters['uLoginInfo/login_token'] === '') {
      next({path: `${user_name}`, query: {type: 'reload'}});
      return;
    }
  } else if (`/${urls[1]}` === `${manage_name}`) {
    if (store.getters['mLoginInfo/login_token'] === null || store.getters['mLoginInfo/login_token'] === '') {
      next({path: `${manage_name}`, query: {redirect: to.fullPath, type: 'reload'}});
      return;
    }
  }
  next();
});

export default router;
